<template>
  <div
    class="main-hovering-btn-layout fade-in"
    id="levels-selection"
    v-if="!hideUi"
    :class="{ shown: isData && allAssetsLoaded }"
  >
    <img
      class="btn hoverable-button level-one"
      :src="getPic('one', false)"
      handler-id="one"
      @mouseover="handleHoverEvent('one')"
      @mouseout="handleUnhoverEvent('one')"
      @click="handleActivateEventInComponent('one', false)"
      @load="mixinsImgLoadHandler('levels-selection')"
    />
    <img
      class="btn hoverable-button level-two"
      :src="getPic('two', $store.getters.getUnlockedLevels[beltColor] <= 1)"
      handler-id="two"
      @mouseover="handleHoverEvent('two')"
      @mouseout="handleUnhoverEvent('two')"
      @click="handleActivateEventInComponent('two', 1)"
      @load="mixinsImgLoadHandler('levels-selection')"
    />
    <img
      class="btn hoverable-button level-three"
      :src="getPic('three', $store.getters.getUnlockedLevels[beltColor] <= 2)"
      handler-id="three"
      @mouseover="handleHoverEvent('three')"
      @mouseout="handleUnhoverEvent('three')"
      @click="handleActivateEventInComponent('three', 2)"
      @load="mixinsImgLoadHandler('levels-selection')"
    />
    <img
      class="btn hoverable-button level-four"
      :src="getPic('four', $store.getters.getUnlockedLevels[beltColor] <= 3)"
      handler-id="four"
      @mouseover="handleHoverEvent('four')"
      @mouseout="handleUnhoverEvent('four')"
      @click="handleActivateEventInComponent('four', 3)"
      @load="mixinsImgLoadHandler('levels-selection')"
    />
    <img
      class="btn hoverable-button level-five"
      :src="getPic('five', $store.getters.getUnlockedLevels[beltColor] <= 4)"
      handler-id="five"
      @mouseover="handleHoverEvent('five')"
      @mouseout="handleUnhoverEvent('five')"
      @click="handleActivateEventInComponent('five', 4)"
      @load="mixinsImgLoadHandler('levels-selection')"
    />
    <img
      class="btn hoverable-button level-six"
      :src="getPic('six', $store.getters.getUnlockedLevels[beltColor] <= 5)"
      handler-id="six"
      @mouseover="handleHoverEvent('six')"
      @mouseout="handleUnhoverEvent('six')"
      @click="handleActivateEventInComponent('six', 5)"
      @load="mixinsImgLoadHandler('levels-selection')"
    />
    <img
      class="btn back"
      :src="getPic('back')"
      handler-id="back"
      @mouseover="handleHoverEvent('back')"
      @mouseout="handleUnhoverEvent('back')"
      @click="handleActivateBack()"
      @load="mixinsImgLoadHandler('levels-selection')"
    />
    <audio
      ref="selectedSound"
      @loadeddata="mixinsImgLoadHandler('levels-selection')"
    >
      <source
        src="../assets/sound/belts_levels_selection.wav"
        type="audio/ogg"
      />
    </audio>
  </div>
</template>

<script>
import handHoverMixin from '../mixins/hand-hover-mixin.js';
import { eventTypes, soundDelay } from '../config/config';
import appConstants from '../config/constants';

export default {
  name: 'LevelsSelection',
  mixins: [handHoverMixin],
  props: {
    isData: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      beltColor: null,
      eventTypes,
      btnClasses: {
        one: '',
        two: '',
        three: '',
        four: '',
        five: '',
        six: '',
        back: ''
      }
    };
  },
  created() {
    this.beltColor = this.$route.params.beltColor;
    if (!this.beltColor) {
      this.$route.push('/');
    }
  },
  methods: {
    navigateBack() {
      this.$router.push('/belts-selection');
    },
    handleActivateEventInComponent(handlerId) {
      const isUnlocked =
        this.$store.getters.getUnlockedLevels[this.beltColor] >=
        appConstants.levelsToNumbers[handlerId];
      // eslint-disable-next-line
      if (isUnlocked && appConstants.levelsArr.includes(handlerId) /* making sure the btn is actually located in this component */) {
        this.$refs.selectedSound.play();
        setTimeout(() => {
          if (handlerId === appConstants.levelsHash.one) {
            this.$router.push(`/animation-generator/${this.beltColor}`);
            return;
          }
          this.$router.push(`/game/${this.beltColor}/${handlerId}`);
        }, soundDelay);
      }
    },
    getImgNameExta(handlerId, isLocked) {
      // if belt is locked, add lock and no hover effect.
      if (isLocked) {
        return '_lock';
      }
      if (
        this.btnClasses[handlerId] === appConstants.hover ||
        this.btnClasses[handlerId] === appConstants.activate
      ) {
        return '_' + appConstants.hover;
      }
      return '';
    },
    getPic(handlerId, isLocked) {
      // isLocked is passed from template
      try {
        if (handlerId === appConstants.back) {
          // eslint-disable-next-line
          return require(`@/assets/img/btns/back${this.getImgNameExta(handlerId)}.png`);
        }
        return require(`@/assets/img/levels/${
          this.beltColor
        }/level_${handlerId}${this.getImgNameExta(handlerId, isLocked)}.png`);
      } catch (err) {
        console.warn({ err });
        try {
          return require(`@/assets/img/belts/${this.beltColor}.png`);
        } catch (error) {
          console.warn({ error });
          return require('@/assets/img/btns/no.png');
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/belts_levels.scss';
</style>
